import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[libItemTemplate]',
  standalone: true,
})
export class ItemTemplateDirective {

  @Input() libItemTemplate?: string;
  @Input() disabled?: boolean;
  constructor(public templateRef: TemplateRef<unknown>) {
  }

}
